import { render, staticRenderFns } from "./GeoShadeAnimation.vue?vue&type=template&id=2b55a179&"
import script from "./GeoShadeAnimation.vue?vue&type=script&lang=js&"
export * from "./GeoShadeAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports